import React from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

const Header = ( { headline }) => {
    return (
        <header className = "header router-nav-links">
            <h1 className = "headline" style = {{display: "inline-block"}} >{ headline }</h1>
            <nav  className = "nav-links">
                    <Link className="links" to= '/' >Home</Link>
                    <Link className="links" to= '/about'>About</Link>
                    <Link className="links" to= '/services'>Services</Link> 
                    <Link className="links" to= '/contact'>Contact</Link>
            </nav>           
        </header>        
    )
}

export default Header